// Simple event bus for clinical/tooth events.
// Framework agnostic, no Redux required.

export type EventHandler = (payload: unknown) => void;

class EventBus {
  private listeners: Record<string, EventHandler[]> = {};

  on(event: string, handler: EventHandler): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(handler);
  }

  off(event: string, handler: EventHandler): void {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter((h) => h !== handler);
  }

  emit(event: string, payload?: unknown): void {
    (this.listeners[event] || []).forEach((handler) => {
      try {
        handler(payload);
      } catch (e) {
        console.error("EventBus handler error", event, e);
      }
    });
  }
}

export const eventBus = new EventBus();
